module.exports = __webpack_public_path__ + "media/images/gifts/care/sug_cuidar_1-f9883f18631af740210aeb5f284d2d2b.jpg";